import actionTypes from '../actionTypes';
export default {
  liveAgentList: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_AGENT_LIST,
      payload: data
    });
  },
  liveFilter: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_FILTER,
      payload: data
    });
  },
  liveStateList: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_STATE_LIST,
      payload: data
    });
  },
  liveQueue: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_QUEUE,
      payload: data
    });
  },
  setLiveAgentList: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_SET_AGENT_LIST,
      payload: data
    });
  },
  setLiveFilter: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_SET_FILTER,
      payload: data
    });
  },
  setLiveStateList: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_SET_STATE_LIST,
      payload: data
    });
  },
  setLiveQueue: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_SET_QUEUE,
      payload: data
    });
  },
  dynamicUpdate: data => dispatch => {
    dispatch({
      type: actionTypes.LIVE_DYNAMIC_UPDATE,
      payload: data
    });
  }
};



// WEBPACK FOOTER //
// ./src/store/action/livemonitor.action.js